export default __webpack_public_path__ + "static/media/tim.18092bf0.svg";